@let error = errorSg();
@let readonly = readonlySg();

<atn-ds-centered-overlay (backdropClick)="onCancelClick()">
  <atn-ds-widget
    title="Knowledge Base Retrieval Context"
    class="atn-assistant-kb-retrieval-dialog__widget"
  >
    <i
      actions
      class="atn-icon atn-close atn-red"
      (click)="onCancelClick()"
    ></i>
    <div class="atn-assistant-kb-retrieval-dialog__content">
      <p class="atn-assistant-kb-retrieval-dialog__description">
        @if (readonly) {
          These records were provided by the workspace context for this session
          and can't be edited here.
        } @else {
          Paste a JSON array of DMS records to authorize for knowledge-base
          retrieval for the next message only, e.g.
          <code>[&#123; "modelId": "...", "recordId": "..." &#125;]</code>
        }
      </p>
      <div class="atn-assistant-kb-retrieval-dialog__editor">
        <atn-ds-code
          [(json)]="jsonSg"
          [readonly]="readonly"
          syntax="json"
        ></atn-ds-code>
      </div>
      @if (error) {
        <p class="atn-assistant-kb-retrieval-dialog__error">{{ error }}</p>
      }
    </div>
    <div
      class="atn-assistant-kb-retrieval-dialog__footer"
      footer
    >
      @if (readonly) {
        <atn-ds-button
          type="transparent"
          (click)="onCancelClick()"
        >
          Close
        </atn-ds-button>
      } @else {
        <atn-ds-button
          type="transparent"
          (click)="onCancelClick()"
        >
          Cancel
        </atn-ds-button>
        <atn-ds-button (click)="onSaveClick()">Save</atn-ds-button>
      }
    </div>
  </atn-ds-widget>
</atn-ds-centered-overlay>
